module.exports = __webpack_public_path__ + "static/img/zt5888336.a2bbeafd.png";